import React from 'react'
import { SEO } from '../../../../components/Seo/seo'
import { AuthenticatedUserConsumer } from '../../../../AuthenticatedUserContext'
import { useParams } from 'react-router-dom'
import NoMatch from '../../../NoMatch'
import { payments } from '../../../../utils/pages-meta'
import { FormattedMessage, useIntl } from 'react-intl'
import InActiveUserContent from '../../../../components/InActiveUserContent'
import { SearchLoader } from '../../../../components/Loader/SearchLoader'
import CompanyPaymentClaimsContent from '../../../../components/Workspace/CompanyPage/CompaniesPaymentClaims'
import { Container } from '@material-ui/core'
import { useStyles } from '../Styles'

const PaymentClaims = () => {
  let { id } = useParams()
  const intl = useIntl()
  const classes = useStyles()
  return (
    <>
      {!!id && !!parseInt(id) ? <>
          <SEO title={intl.formatMessage({ id: 'PageTitle.Payments' })}
               pathname={window.location.origin}
               titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
               image={payments.image}
               description={intl.formatMessage({ id: 'PageTitle.Payments' })}
          />
          <AuthenticatedUserConsumer>
            {({ userDataLoading, isUserActive, userData, checkCompanyData }) => (
              <>
                <Container maxWidth="lg" className={classes.TitleContainer}>
                  <h1><FormattedMessage id='PageTitle.Payments'/></h1>
                </Container>
                {!!userDataLoading && <SearchLoader loading={true}/>}
                {(!!Object.keys(userData).length && !!isUserActive) ?
                  <CompanyPaymentClaimsContent checkCompanyData={checkCompanyData} cid={id}/>
                  : (!userDataLoading && <InActiveUserContent/>)
                }
              </>
            )}
          </AuthenticatedUserConsumer>
        </> :
        <NoMatch/>
      }
    </>
  )
}

export default PaymentClaims
